import { render, staticRenderFns } from "./AddRatePlan.vue?vue&type=template&id=7e66a9d7&"
import script from "./AddRatePlan.vue?vue&type=script&lang=js&"
export * from "./AddRatePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports